import {graphql, useStaticQuery} from "gatsby";

const partners = [
  // {
  //   name: "Consiliul Județean Timiș",
  //   logoName: "consiliul-judetean-timis",
  //   website: "http://www.cjtimis.ro/",
  //   type: ["funder"]
  // },
  // {
  //   name: "Alex Cover",
  //   logoName: "alex-cover",
  //   website: "https://www.alexcover.ro/",
  //   socialMedia: [
  //     {
  //       type: "facebook",
  //       link: "https://www.facebook.com/AlexCoverAlbume/"
  //     }
  //   ],
  //   description: [
  //     {
  //       type: "paragraph",
  //       value: `Compania a fost înființată în anul 1997  sub numele Agenția Șerbănescu, având ca domeniu de activitate principal tiparul digital. În 2007 au achiziționat primul laborator foto Noritsu, iar 4 ani mai târziu au început producția de albume, în prezent realizând o gamă variată de albume foto digitale, cu coperte din diferite materiale: piele naturală, piele sintetică, bumbac natural, velur, coperte foto laminate, dar și cutii pentru albume, carcase pentru flash drive-uri si DVD-uri, necesare fotografilor pentru livrarea pozelor către clienți.`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Alex Cover aduce la ITF o gamă largă de albume foto, cât și cutii pentru albume. De asemenea, vor prezenta și carcase pentru flash drive-uri și DVD-uri, dar și produse complementare. Descoperă și noua colecție de albume 2019-2020, creată special de echipa Alex Cover, pentru a putea oferi aminitiri memorabile.`
  //     },
  //   ],
  //   type: ["partner"]
  // },
  // {
  //   name: "Anghel Brothers Studio",
  //   logoName: "anghel-brothers-studio",
  //   website: "https://anghelbrotherstudio.ro/",
  //   type: ["partner"]
  // },
  // {
  //   name: "CEWE",
  //   logoName: "cewe",
  //   website: "https://cewe.ro/",
  //   socialMedia: [
  //     {
  //       type: "facebook",
  //       link: "https://www.facebook.com/cewefotocarte/"
  //     }
  //   ],
  //   description: [
  //     {
  //       type: "paragraph",
  //       value: `CEWE este cel mai mare procesator de fotografie din Europa, cu o istorie de peste 100 de ani în acest domeniu. Aceștia asigură o calitate impecabilă a serviciilor laboratorului foto digital online, realizând cele mai frumoase aminitiri într-un mod creativ și modern: CEWE FOTOCARTE, calendare, decoraţiuni de perete, felicitări sau obiecte cadou.`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Vino la standul Cewe și descoperă cel mai nou echipament instant print și transformă-ți fotografiile în amintiri care se pot dărui! Descoperă și Fotocartea cu efect de lăcurie pe copertă, produsul care le-a adus, pentru a 3-a oară consecutiv, premiul TIPA World Award. Nici o altă companie din acest domeniu nu a câștigat favoarea juriului internațional în categoria „Best Photo Print Service”. Vrei să te convingi? Descoperă noile tipuri noi de produse deco: alu-dibond, sticla, canvas, forex sau chiar lemn. Poți alege o fotografie și ei se vor ocupa de tot ce înseamnă print pentru un efect garantat. CEWE  e alături de participanții ITF și dorește să le faci o surpriză celor dragi ție: trimite-le o carte poștală gratuit direct din aplicația CEWE!`
  //     }
  //   ],
  //   type: ["partner"]
  // },
  // {
  //   name: "CBS Pro",
  //   logoName: "cbs-pro",
  //   website: "https://www.cbspro.ro/",
  //   type: ["partner"]
  // },
  // {
  //   name: "F64",
  //   logoName: "f64",
  //   website: "https://www.f64.ro/",
  //   socialMedia: [
  //     {
  //       type: "facebook",
  //       link: "https://www.facebook.com/F64.ro/"
  //     }
  //   ],
  //   description: [
  //     {
  //       type: "paragraph",
  //       value: `F64 este este cel mai mare concept store foto-video din Sud-Estul Europei, unde găseşti ultimele noutăţi din domeniu, dar şi cea mai diversificată gamă de echipamente, la cea mai bună calitate. Fotografia însă, nu se rezumă doar la aparatură și drept urmare, F64 se concentrează pe comunitatea foto și urmărește atât partea educativă cât și cea creativă prin intermediul evenimentelor,  workshop-urilor, cursurilor și expozițiilor.`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Descoperă zona de testare, la standul F64, unde poți să faci cunoștință cu cea mai noua gamă de obiective Sigma - L- Mount cu distanță focală fixă pentru senzori full-frame, din seria Sigma Global Vision – ART, acoperind focale de la 14 mm până la 135 mm, cu un autofocus reglat care permite fotografierea la viteze mari și sunt compatibile cu stabilizarea de imagine din corpul aparatului foto. Acestea oferă posibilitatea realizării unei fotografii de calitate superioară cu ajutorul datelor pre-încărcate care facilitează corecția aberațiilor cromatice în interiorul camerei (corecții pentru iluminare periferică, aberații cromatice și distorsiuni geometrice).`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Vedeta din cadrul ITF va fi ConceptD, noua familie de produse special gândite și construite pentru a face față provocărilor din munca unui creator. Descoperă brandul care răspunde nevoilor tale specifice și este punctul de întâlnire dintre Concept -  viziune și „D”, fie că este vorba despre dinamism, design, descoperire, detaliu, dezvoltare, sau despre cu totul altceva.`
  //     },
  //   ],
  //   type: ["partner"]
  // },
  // {
  //   name: "Fotika",
  //   logoName: "fotika",
  //   website: "https://fotika.ro/",
  //   socialMedia: [
  //     {
  //       type: "facebook",
  //       link: "https://www.facebook.com/fotikaromania"
  //     }
  //   ],
  //   description: [
  //     {
  //       type: "paragraph",
  //       value: `Fotika este una din companiile de top din industria foto din Romania, cu o experiență de peste 25 ani în  domeniul print-ului foto și de peste 9 ani a pășit cu încredere în activatea de producție de albume și accesorii foto. Misiunea lor este să pună la dispoziție un serviciu complet fotografilor și videografilor profesioniști prin procesarea comenzilor online, accesibil oricui cu acces la internet și de oriunde.`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Treci pe la standul Fotika și descoperă cea mai mare gamă de albume foto disponbilă. Pregătește-te pentru surprize și descoperă modele de albume în care poți să le livrezi clienților fotografiile de eveniment!`
  //     },
  //   ],
  //   type: ["partner"]
  // },
  {
    name: "Fotografi-Cameramani",
    logoName: "fotografi-cameramani",
    website: "https://www.fotografi-cameramani.ro/",
    type: ["partner", "media"]
  },
  {
    name: "Ghidul DSLR",
    logoName: "ghidul-dslr",
    website: "https://www.ghiduldslr.ro/",
    type: ["partner", "media"]
  },
  {
    name: "Radio Timișoara",
    logoName: "radio-romania-timisoara",
    website: "http://www.radiotimisoara.ro/",
    type: ["partner", "media"]
  },
  {
    name: "Tion",
    logoName: "tion",
    website: "http://www.tion.ro/",
    type: ["partner", "media"]
  },
  {
    name: "TVR",
    logoName: "tvr",
    website: "https://tvr.ro/",
    type: ["partner", "media"]
  },
  {
    name: "HDV Studio",
    logoName: "hdv-studio",
    website: "https://hdv.ro/",
    type: ["partner", "logistic"]
  },
  {
    name: "Anghel Brothers Studio",
    logoName: "anghel-brothers-studio",
    website: "https://anghelbrotherstudio.ro/",
    type: ["partner", "logistic"]
  },
  {
    name: "CEWE",
    logoName: "cewe",
    website: "https://cewe.ro/",
    socialMedia: [
      {
        type: "facebook",
        link: "https://www.facebook.com/cewefotocarte/"
      }
    ],
    description: [
      {
        type: "paragraph",
        value: `CEWE este cel mai mare procesator de fotografie din Europa, cu o istorie de peste 100 de ani în acest domeniu. Aceștia asigură o calitate impecabilă a serviciilor laboratorului foto digital online, realizând cele mai frumoase aminitiri într-un mod creativ și modern: CEWE FOTOCARTE, calendare, decoraţiuni de perete, felicitări sau obiecte cadou.`
      },
      {
        type: "paragraph",
        value: `Vino la standul Cewe și descoperă cel mai nou echipament instant print și transformă-ți fotografiile în amintiri care se pot dărui! Descoperă și Fotocartea cu efect de lăcurie pe copertă, produsul care le-a adus, pentru a 3-a oară consecutiv, premiul TIPA World Award. Nici o altă companie din acest domeniu nu a câștigat favoarea juriului internațional în categoria „Best Photo Print Service”. Vrei să te convingi? Descoperă noile tipuri noi de produse deco: alu-dibond, sticla, canvas, forex sau chiar lemn. Poți alege o fotografie și ei se vor ocupa de tot ce înseamnă print pentru un efect garantat. CEWE  e alături de participanții ITF și dorește să le faci o surpriză celor dragi ție: trimite-le o carte poștală gratuit direct din aplicația CEWE!`
      }
    ],
    type: ["partner", "logistic"]
  },
  {
    name: "Photometria",
    logoName: "photometria",
    website: "https://www.photometria.gr/",
    type: ["partner", "logistic"]
  },
  {
    name: "PhotoRomania",
    logoName: "photo-romania",
    website: "https://www.photoromaniafestival.ro/",
    type: ["partner", "logistic"]
  },
  {
    name: "Budapest Photo Festival",
    logoName: "budapest-photo-festival",
    website: "https://www.budapestphotofestival.hu/",
    type: ["partner", "logistic"]
  },
  {
    name: "FITT",
    logoName: "fitt",
    website: "https://fitt.ro/",
    type: ["partner", "logistic"]
  },
  // {
  //   name: "Panasonic",
  //   logoName: "panasonic",
  //   website: "https://www.panasonic.com/ro/",
  //   socialMedia: [
  //     {
  //       type: "facebook",
  //       link: "https://www.facebook.com/PanasonicCorporation/"
  //     }
  //   ],
  //   description: [
  //     {
  //       type: "paragraph",
  //       value: `Panasonic Corporation este lider mondial în dezvoltarea de tehnologii electronice diverse şi soluţii pentru clienţi în domeniul electronicelor de consum, aplicaţiilor rezidenţiale, auto, a soluţiilor profesionale şi a echipamentelor industriale. Compania Panasonic care, în 2018, a aniversat 100 de ani la înfiinţarea sa, este activă la nivel global, fiind prezentă acum în 582 de sucursale şi 87 de societăţi asociate la nivel mondial.`
  //     },
  //     {
  //       type: "paragraph",
  //       value: `Vino la standul Panasonic și descoperă întreaga gamă de camere Full Frame Lumix S, dedicate profesioniștilor.  Totodată, vei putea testa modelele expuse și vei avea ocazia să stai de vorbă direct cu specialiștii Panasonic. Produsul vedetă pe care îl vei putea testa este camera Lumix S1H, proaspăt lansat pe piață, acesta fiind dedicat în principal videografilor profesioniști, camera putând înregistra la o calitate specifică modelelor de studio.`
  //     },
  //   ],
  //   type: ["partner"]
  // },
  // {
  //   name: "Romtek x Sony",
  //   logoName: "romtek-x-sony",
  //   website: "https://www.romtek.ro/",
  //   type: ["partner"]
  // },
  // {
  //   name: "Sony",
  //   logoName: "sony",
  //   website: "https://www.sony.ro/",
  //   type: ["partner"]
  // },
];
const PartnerLogos = () => {
  const results = useStaticQuery(graphql`
  query {
    partnerLogos: allFile(
      filter:{
        extension: { regex: "/jpeg|jpg|png|gif/"}
        relativeDirectory: { eq: "partner-logos" }
      }
    ) {
      edges {
        node {
          name
          base
          relativePath
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`);

  return results.partnerLogos.edges.map(result => result.node);
};

const partnerByType = type => partner => partner.type.includes(type);
const AddLogo = (partner) => ({
  ...partner,
  logo: PartnerLogos().find(logo => logo.name === partner.logoName) || PartnerLogos().find(logo => logo.name === 'default')
});

export const usePartnerLogos = () => PartnerLogos();
export const usePartners = () => partners.filter(partnerByType('partner')).map(AddLogo);
export const useMediaPartners = () => usePartners().filter(partnerByType('media')).map(AddLogo);
export const useLogisticPartners = () => usePartners().filter(partnerByType('logistic')).map(AddLogo);
export const useFunders = () => partners.filter(partnerByType('funder')).map(AddLogo);
export const useOrganisers = () => partners.filter(partnerByType('organiser')).map(AddLogo);